const PO_ID = /^[A-Za-z0-9_-]{1,80}$/;
export const isCustomerPoId = value => typeof value === 'string' && PO_ID.test(value);
export const PO_SELECTION_ERROR = "PO belum dapat dimuat. Silakan coba lagi.";

// Validate the private response before replacing any visible customer snapshot.
// An explicitly selected PO must never silently fall back to another trip.
export function customerPoSelection(response, requestedId) {
    const fail = () => {
        const error = new Error(PO_SELECTION_ERROR);
        error.authoritative = true;
        throw error;
    };
    const selected = response.po;
    if (requestedId && (!PO_ID.test(requestedId) || selected?.id !== requestedId)) fail();
    if (selected != null && (typeof selected.id !== 'string' || !PO_ID.test(selected.id))) fail();
    if (response.po_options === undefined) {
        // Older server responses can still show their single current PO.
        return { id: selected?.id || '', options: selected ? [selected] : [] };
    }
    if (!Array.isArray(response.po_options)) fail();
    const seen = new Set();
    const options = response.po_options.map((po) => {
        if (!po || typeof po.id !== 'string' || !PO_ID.test(po.id) || seen.has(po.id) ||
            typeof po.name !== 'string' || typeof po.status !== 'string') fail();
        seen.add(po.id);
        return { id: po.id, name: po.name, status: po.status };
    });
    if (selected ? !seen.has(selected.id) : options.length !== 0) fail();
    return { id: selected?.id || '', options };
}
